var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.374 5.27983C22.3891 5.50321 22.3891 5.72659 22.3891 5.95203C22.3891 12.8213 17.2681 20.7436 7.90423 20.7436V20.7395C5.1381 20.7436 2.42943 19.9345 0.1008 18.4089C0.503017 18.4584 0.907251 18.4831 1.31249 18.4841C3.60483 18.4861 5.83165 17.7007 7.63507 16.2544C5.45665 16.2122 3.54636 14.7617 2.87903 12.6442C3.64213 12.7945 4.42842 12.7636 5.17741 12.5547C2.80241 12.0647 1.09374 9.9338 1.09374 7.45909C1.09374 7.43644 1.09374 7.41483 1.09374 7.39321C1.8014 7.79571 2.59374 8.01909 3.40423 8.0438C1.16733 6.51718 0.477816 3.47835 1.82862 1.10247C4.4133 4.35027 8.22681 6.32468 12.3206 6.53365C11.9103 4.72806 12.4708 2.836 13.7933 1.56674C15.8437 -0.401498 19.0685 -0.300616 20.996 1.79218C22.1361 1.56262 23.2288 1.13541 24.2288 0.530119C23.8488 1.7335 23.0534 2.75571 21.9909 3.40527C23 3.2838 23.9859 3.00791 24.9143 2.58688C24.2308 3.63277 23.37 4.5438 22.374 5.27983Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.b0dc2bdcc5e792823ccea0f90df3f931.svg";
export { ForwardRef as ReactComponent };